import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { TextButton } from "../components/TextButton";

interface LicenseStateTextProps {
  state: string;
  nlcStates: Set<string>;
  multiState: boolean;
  onNlcStatesClick: () => void;
}

export function LicenseStateText(props: LicenseStateTextProps) {
  const { state, nlcStates, multiState, onNlcStatesClick } = props;

  const isNlcState = nlcStates.has(state);

  return (
    <Stack sx={{ flexDirection: "row", alignItems: "baseline", gap: 2 }}>
      <Text semibold variant="body1" sx={{ whiteSpace: "pre" }}>
        {state} {isNlcState && multiState ? " &" : ""}
      </Text>

      {isNlcState && multiState && (
        <TextButton withRightArrow size="large" onClick={onNlcStatesClick}>
          {nlcStates.size - 1} NLC states
        </TextButton>
      )}
    </Stack>
  );
}
